// src/services/api.ts
import axios from 'axios';

const API_BASE_URL = 'http://localhost/iga/backend/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const apiService = {
  // Projects
  getProjects: () => api.get('/projects'),
  getProjectsByCategory: (category: string) => api.get(`/projects?category=${category}`),
  
  // Blogs
  getBlogs: () => api.get('/blogs'),
  getBlogBySlug: (slug: string) => api.get(`/blogs?slug=${slug}`),
  
  // Impact Stats
  getImpactStats: () => api.get('/impact-stats'),
  
  // Forms
  submitVolunteer: (data: any) => api.post('/volunteers', data),
  submitContact: (data: any) => api.post('/messages', data),
  submitDonation: (data: any) => api.post('/donations', data),
};

export default api;